import PropTypes from 'prop-types';

import RotatingLines from './rotatingLines';
import TailSpin from './tailSpin';

import s from './loaderIndicator.module.css';

function LoaderIndicator({ mode = 'RotatingLines' }) {
  return (
    <div className={s.container}>
      {mode === 'RotatingLines' && (
        <RotatingLines width={60} height={60} color="#1756EC" strokeWidth={4} />
      )}
      {mode === 'TailSpin' && (
        <TailSpin width={60} height={60} color="#1756EC" strokeWidth={4} />
      )}
    </div>
  );
}

export default LoaderIndicator;

LoaderIndicator.propTypes = {
  mode: PropTypes.oneOf(['RotatingLines', 'TailSpin']),
};
